import React from "react";
import { Avatar } from "@mui/material";

interface User {
  id: number;
  name: string;
  avatarUrl?: string;
  score?: number;
  department?: string;
}

interface TopUserProps {
  user: User;
  position: number;
}

const medalIcons: { [key: number]: string } = {
  1: "🥇",
  2: "🥈",
  3: "🥉",
};

const TopUser: React.FC<TopUserProps> = ({ user, position }) => {
  return (
    <div
      className={`podium-user ${
        position === 1
          ? "podium-center"
          : position === 2
          ? "podium-right"
          : "podium-left"
      }`}
    >
      <div className="position">{medalIcons[position]}</div>
      <div className="avatar">
        {user.avatarUrl ? (
          <Avatar
            src={user.avatarUrl}
            alt={user.name}
            sx={{ width: 50, height: 50 }}
          />
        ) : (
          <Avatar sx={{ width: 50, height: 50 }} />
        )}
      </div>
      <div>
        <div className="name user-name">{user.name}</div>
        <div className="name user-department">
          {user.department && `(${user.department})`}
        </div>
      </div>
      {user.score !== undefined && <div className="score"> % {user.score}</div>}
    </div>
  );
};

export default TopUser;
